const Tooltip = ({message}) => {
    return (
        <div className="absolute p-2 mt-20 border rounded ml-44 min-w-max bg-bglight dark:bg-bgdark border-borderlighthover dark:border-borderdark z-1110">
            <span className="text-sm font-light text-textlight dark:text-textdark">💡 {message}</span>
        </div>

    )
}

export default Tooltip
